class Accordion {

    constructor(accordionSelector, toggleAccordionSelector, contentSelector) {
        this.accordionSelector = accordionSelector;
        this.contentSelector = contentSelector;
        this.$accordions = $(this.accordionSelector);
        this.$toggleAccordion = $(toggleAccordionSelector);
        this.ACTIVE_CLASS = 'is-open';
    }

    initClickHandling() {
        this.$toggleAccordion.on('click', {
            self: this
        }, this.toggle);
    }

    toggle(event) {
        event.stopPropagation();
        let self = event.data.self;

        let $accordion = $(event.target).closest(self.accordionSelector);

        if ($accordion.hasClass(self.ACTIVE_CLASS)) {
            $accordion.removeClass(self.ACTIVE_CLASS);
            $accordion.find(self.contentSelector).stop().slideUp();
        } else {
            self.$accordions.removeClass(self.ACTIVE_CLASS);
            self.$accordions.find(self.contentSelector).stop().slideUp();

            $accordion.addClass(self.ACTIVE_CLASS);
            $accordion.find(self.contentSelector).stop().slideDown();
        }
    }
}
